import React from 'react';

import { RouteComponentProps } from "@reach/router";

import { MenuCertificates } from "ui/organisms/MenuCertificates";

export const Certificates: React.FC<RouteComponentProps> = () => <MenuCertificates />;
